import { type PublishRecordFragment } from "@ihr-radioedit/inferno-webapi";

export interface PodcastEmbed {
  isPodcastEmbed?: boolean;
}

export function getPodcastEmbed(content: PublishRecordFragment) {
  return !!content?.payload?.feed_vendor && !!content?.payload?.feed_permalink;
}
